import React, { Component } from 'react';
import ReactTable from 'react-table';
import reqwest from 'reqwest';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import history from '../../history';
import settings from '../../../settings';
import Loader from '../../components/Loader';
import Searchbar from '../../components/Searchbar';
import Button from '../../components/Button';

class VisitsOverview extends Component {
  constructor(props) {
    super(props);

    let searchString = '';
    if (props.match.params.search) {
      searchString = props.match.params.search;
    }

    this.state = {
      loading: true,
      data: [],
      searchString,
    };
  }

  componentDidMount() {
    const promise = reqwest({
      method: 'get',
      url: settings.visits.getListForUser,
      data: {
        Token: localStorage.getItem('token'),
        UserGuid: JSON.parse(localStorage.getItem('userdata')).userGuid,
      },
    }).then(res => {
      // Todo: Fix this please
      if (res === 'No data') res = [];

      this.setState({
        data: JSON.parse(res).map(d => d.Guid !== ''),
      });
    });

    Promise.all([promise]).then(() => {
      this.setState({
        loading: false,
      });
    });
  }

  _search = value => {
    const val = value.toLowerCase();

    history.replace(val ? `/visits/search/${val}` : '/visits');

    this.setState({
      searchString: val,
    });
  };

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    const data = this.state.data.filter(rowData => {
      if (!rowData.length) return;
      return [rowData.Date, rowData.CCR]
        .map(e => e.toLowerCase())
        .some(v => {
          return v.indexOf(this.state.searchString) >= 0;
        });
    });

    return (
      <>
        <div className='Toolbar'>
          <Searchbar placeholder='Besuchstermin suchen...' defaultValue={this.state.searchString} onChange={this._search} />
          <div className='Toolbar-buttons'>
            <Button icon={faPlus} to='/visits/new'>
              Besuchstermin erstellen
            </Button>
          </div>
        </div>
        <ReactTable
          getTrProps={(_, { original }) => ({
            onClick: () => this.props.history.push(`/visits/${original.Guid}`),
          })}
          data={data}
          pageSize={data.length}
          noDataText='Es wurden keine Besuchstermine gefunden.'
          columns={[
            {
              Header: 'Datum',
              accessor: 'Date',
            },
            {
              Header: 'KST',
              accessor: 'CCR',
            },
          ]}
        />
      </>
    );
  }
}

export default VisitsOverview;
